import React, { useEffect, useRef, useState, useCallback } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useDispatch, useSelector } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import CustomerConstants from "../../../../common/CustomerConstants";

import DeleteMaterialV5 from "./DeleteMaterialV5";
import CatalogProductDetailModalV5 from "../Common/CatalogModal/CatalogProductDetailModalV5";

import MaterialBarCodeModal from "./MaterialBarCodeModal";

import { SearchField } from "../../../../Components/formElements/SearchField";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
// import ShowUploadImageV5 from "./ShowUploadImageV5";
// import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { OverlayTrigger, Tooltip, Modal, Button, Form } from "react-bootstrap";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import {
  addMaterial,
  //   getMaterialList,
  materialBarcodeList,
} from "../../../../redux/feature/customer_app/customerSlice";
// import MaterialHBModalV5 from "./MaterialHBModalV5";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { formatDate } from "../../../../common/Validations";
import MaterialListQualityCheckModal from "./MaterialListQualityCheckModal";
import ConversionHistoryModal from "./ConversionHistoryModal ";
import { useReactToPrint } from "react-to-print";
// import { BarcodePrintComponent } from "./BarcodePrintComponent";
// import { Barcode } from "lucide-react";

import Barcode from "react-barcode";
// eslint-disable-next-line
import QRCode from "react-qr-code";
import toast from "react-hot-toast";
import MaterialHBModalV5Barcode from "./MaterialHBModalV5Barcode";
import { TruckElectric } from "lucide-react";
// import { Form } from "react-router-dom";

// const POLLING_INTERVAL_MS = 0; // 30 seconds

const MaterialBarcodeList = () => {
  localStorage.setItem("menu", "Barcode");
  localStorage.setItem("submenu", "Rent Product");

  const dispatch = useDispatch();

  let materialData = useSelector(
    (state) => state?.customer?.materialBarcode?.data,
  ); // User Details from Store
  let materialTable = useSelector(
    (state) => state?.customer?.materialBarcode?.pagination,
  );

  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [getNewPerPage, setNewPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState();

  const currentPageRef = useRef(1);
  const perPageRef = useRef(100);
  const searchTermRef = useRef("");
  const pollingTimerRef = useRef(null);

  const [modalDeleteMaterial, setModalDeleteMaterial] = useState(false);
  const [modalShowAddProduct, setModalShowAddProduct] = useState(null);
  const [modalShowAddProductMaterial, setModalShowAddProductMaterial] =
    useState();
  const [modalShowDetailProduct, setModalShowDetailProduct] = useState(false);

  const [isCardVisible2, setCardVisible2] = useState(true);

  const [getData, setData] = useState();
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  // eslint-disable-next-line
  const [getFileViewData, setFileViewData] = useState(null);
  // eslint-disable-next-line
  const [activeFilters, setActiveFilters] = useState([]);
  const activeFiltersRef = useRef([]);

  const target = useRef(null);

  //   const getRoiExpiryDate = (createdOn) => {
  //   if (!createdOn) return "--";

  //   const date = new Date(createdOn);
  //   date.setMonth(date.getMonth() + 36);

  //   return date.toISOString().split("T")[0]; // YYYY-MM-DD
  // };

  const getRoiExpiryDate = (createdOn) => {
    if (!createdOn) return null;

    const date = new Date(createdOn);
    date.setMonth(date.getMonth() + 36);

    return date; // return Date object
  };

  const getRoiAgeMonthsDays = (createdOn) => {
    if (!createdOn) return "--";

    const start = new Date(createdOn);
    const today = new Date();

    if (today < start) return "0 Days";

    let years = today.getFullYear() - start.getFullYear();
    let months = today.getMonth() - start.getMonth();
    let days = today.getDate() - start.getDate();

    if (days < 0) {
      // previous month days
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
      months -= 1;
    }

    if (months < 0) {
      months += 12;
      years -= 1;
    }

    const totalMonths = years * 12 + months;

    let result = "";
    if (totalMonths > 0)
      result += `${totalMonths} Month${totalMonths > 1 ? "s" : ""} `;
    result += `${days} Day${days !== 1 ? "s" : ""}`;

    return result.trim();
  };

  const [qcType, setQcType] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [showQCModal, setShowQCModal] = useState(false);
  const [qualityCheckItems, setQualityCheckItems] = useState([]);

  // --- New States for Print Quantity ---
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printQuantity, setPrintQuantity] = useState(1); // Default 1 copy
  const [printType, setPrintType] = useState(""); // "BARCODE" or "QR"
  const [printRowData, setPrintRowData] = useState(null); // Selected row data

  //  NEW - Central reload function
  // const reloadData = useCallback(
  //   (page, perPage, searchTerm) => {
  //     const p = page !== undefined ? page : currentPageRef.current;
  //     const pp = perPage !== undefined ? perPage : perPageRef.current;
  //     const st = searchTerm !== undefined ? searchTerm : searchTermRef.current;
  //     dispatch(
  //       materialBarcodeList({
  //         queryName: "MaterilBarcodeListRE",
  //         page: p,
  //         per_page: pp,
  //         searchTerm: st,
  //       }),
  //     );
  //   },
  //   [dispatch],
  // );

  const reloadData = useCallback(
    (page, perPage, searchTerm, filters) => {
      const p = page !== undefined ? page : currentPageRef.current;
      const pp = perPage !== undefined ? perPage : perPageRef.current;
      const st = searchTerm !== undefined ? searchTerm : searchTermRef.current;
      const f = filters !== undefined ? filters : activeFiltersRef.current;

      dispatch(
        materialBarcodeList({
          queryName: "MaterilBarcodeListRE",
          page: p,
          per_page: pp,
          searchTerm: st,
          rowFilter: f.length > 0 ? { $and: f } : {},
        }),
      );
    },
    [dispatch],
  );
  //  NEW - Start polling
  // const startPolling = useCallback(() => {
  //   if (pollingTimerRef.current) clearInterval(pollingTimerRef.current);
  //   pollingTimerRef.current = setInterval(() => {
  //     reloadData();
  //   }, POLLING_INTERVAL_MS);
  // }, [reloadData]);

  //  NEW - Stop polling
  const stopPolling = useCallback(() => {
    if (pollingTimerRef.current) {
      clearInterval(pollingTimerRef.current);
      pollingTimerRef.current = null;
    }
  }, []);

  //  NEW - Tab fresh data
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        reloadData();
        // startPolling();
      } else {
        // stopPolling();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [reloadData, stopPolling]);

  useEffect(() => {
    if (!materialData || materialData.length === 0) return;

    const qcItems = [];

    materialData.forEach((row) => {
      // API lo already QC details unte
      if (row.qualityCheckDetails?.length) {
        row.qualityCheckDetails.forEach((qc) => {
          qcItems.push({
            ...row,
            ...qc, // modelMatch, brandMatch etc
            grnItemNr: qc.grnItemNr,
            qcType: qc.qcType,

            hasPhysicalQC: qc.qcType === "PHYSICAL",
            hasSpecificationQC: qc.qcType === "SPECIFICATION",
          });
        });
      }
    });

    setQualityCheckItems(qcItems);
  }, [materialData]);

  const handleViewQC = (type, row) => {
    const savedQC = qualityCheckItems.find(
      (item) => item.grnItemNr === row.grnItemNr && item.qcType === type,
    );

    setQcType(type);
    setSelectedRow({
      ...row,
      ...(savedQC || {}),
    });
    setShowQCModal(true);
  };
  // eslint-disable-next-line
  const handleCheckboxClick = (type, row, e) => {
    e.preventDefault();

    const isChecked =
      type === "PHYSICAL" ? row.hasPhysicalQC : row.hasSpecificationQC;

    if (isChecked) {
      // Already checked - view existing data
      handleViewQC(type, row);
    } else {
      handleQCCheck(type, row);
    }
  };
  const handleQCCheck = (type, row) => {
    // Find existing QC data
    const existingQC = qualityCheckItems.find(
      (item) => item.grnItemNr === row.grnItemNr && item.qcType === type,
    );

    setQcType(type);
    setSelectedRow({
      ...row,
      ...(existingQC || {}),
    });
    setShowQCModal(true);
  };

  // new
  const handleSaveQualityCheck = (qcPayload) => {
    setQualityCheckItems((prev) => {
      const index = prev.findIndex(
        (item) =>
          item.grnItemNr === qcPayload.grnItemNr &&
          item.qcType === qcPayload.qcType,
      );

      // UPDATE EXISTING
      if (index !== -1) {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          ...qcPayload,
          hasPhysicalQC: qcPayload.qcType === "PHYSICAL",
          hasSpecificationQC: qcPayload.qcType === "SPECIFICATION",
        };
        return updated;
      }

      // ADD NEW
      return [
        ...prev,
        {
          ...qcPayload,
          hasPhysicalQC: qcPayload.qcType === "PHYSICAL",
          hasSpecificationQC: qcPayload.qcType === "SPECIFICATION",
        },
      ];
    });
  };

  const barcodeRef = useRef();
  const qrCodeRef = useRef();

  const PrintableQrcode = React.forwardRef(({ data, quantity }, ref) => {
    if (!data) return null;

    const items = Array.from({ length: quantity > 0 ? quantity : 1 });

    const qrValue = `
    Code: ${data.materialCode}
    MRP: ${data.mrPrice} INR
    Barcode ID: ${data.barcode}
  `;

    return (
      <div ref={ref} style={{ padding: "20px", width: "100%" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            gap: "15px",
          }}
        >
          {items.map((_, index) => (
            <div
              key={index}
              style={{
                width: "30%",
                border: "1px dashed #ccc",
                padding: "15px",
                marginBottom: "15px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                pageBreakInside: "avoid",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <QRCode value={qrValue} size={120} />{" "}
                {/* Size konchem taggincha fit avvadaniki */}
                <div style={{ marginTop: "10px", fontSize: "12px" }}>
                  <p className="m-0">
                    <strong>{data.materialCode}</strong>
                  </p>
                  <p className="m-0">{data.barcode}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  });

  //   const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //     if (!data) return null;

  //     const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //     return (
  //       <div ref={ref} style={{ padding: "20px", width: "100%" }}>
  //         <div
  //           style={{
  //             display: "flex",
  //             flexWrap: "wrap",
  //             justifyContent: "flex-start",
  //             gap: "15px",
  //           }}
  //         >
  //           {items.map((_, index) => (
  //             <div
  //               key={index}
  //               style={{
  //                 width: "100%",
  //                 height:"100%",
  //                 // border: "1px dashed #ccc",
  //                 padding: "80px",
  //                 marginBottom: "15px",
  //                 marginTop: "20px",
  //                 display: "flex",
  //                 flexDirection: "column",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 pageBreakInside: "avoid",
  //               }}
  //             >
  //               <div style={{ textAlign: "center" }}  >
  //               <div style={{ width: "189px", height: "113px", overflow: "hidden" , transform: "rotate(90deg)",
  // }} >

  //                 <Barcode
  //                   value={data.barcode || "N/A"}
  //                   width={1.5}
  //                   height={60}
  //                   format="CODE128"
  //                   displayValue={true}
  //                   fontSize={14}

  //                 />
  //                 </div>
  //                 {/*<div style={{ marginTop: "5px", fontSize: "12px" }}>
  //                   <p className="m-0">
  //                     <strong>{data.materialCode}</strong>
  //                   </p>
  //                   <p className="m-0">MRP: {data.mrPrice}</p>
  //                 </div>*/}
  //               </div>
  //             </div>
  //           ))}
  //         </div>
  //       </div>
  //     );
  //   });

  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;

  //   const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: 30mm 50mm;   /* ✅ CHANGED: portrait */
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //             width: 30mm;       /* ✅ CHANGED */
  //           }
  //           .barcode-label {
  //             width: 30mm;       /* ✅ CHANGED */
  //             height: 50mm;      /* ✅ CHANGED */
  //             display: flex;
  //             flex-direction: column;
  //             align-items: center;
  //             justify-content: center;
  //             page-break-after: always;
  //             overflow: hidden;
  //           }
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {items.map((_, index) => (
  //          <div
  //   key={index}
  //   className="barcode-label"
  //   style={{
  //     width: "113px",
  //     height: "189px",
  //     display: "flex",
  //     alignItems: "center",
  //     justifyContent: "center",
  //     border: "1px dashed #ccc",
  //     marginBottom: "8px",
  //     marginTop: "20px",
  //     overflow: "hidden",
  //   }}
  // >
  //   {/* ✅ Rotation wrapper — 90 degrees */}
  //   <div
  //     style={{
  //       transform: "rotate(90deg)",
  //       transformOrigin: "center center",
  //       width: "189px",   //  barcode width = label height
  //       height: "113px",  //  barcode height = label width
  //       display: "flex",
  //       alignItems: "center",
  //       justifyContent: "center",
  //     }}
  //   >
  //     <Barcode
  //       value={data.barcode || "N/A"}
  //       width={1.2}
  //       height={90}       //  label width (113px) lo fit avvadam kosam
  //       format="CODE128"
  //       displayValue={true}
  //       fontSize={10}
  //       margin={2}
  //     />
  //   </div>
  // </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });

  const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
    if (!data) return null;

    const items = Array.from({ length: quantity > 0 ? quantity : 1 });

    return (
      <>
        <style>{`
        @media print {
          @page {
            size: 30mm 50mm;
            margin: 0;
          }
          body * { visibility: hidden; }
          #barcode-print-area, #barcode-print-area * { visibility: visible; }
          #barcode-print-area {
            position: absolute;
            left: 2mm;
            top: 2mm;
            width: 30mm;
          }
          .barcode-label {
            width: 30mm;
            height: 50mm;
            page-break-after: always;
            overflow: hidden;
            box-sizing: border-box;
          }
        }
      `}</style>

        <div id="barcode-print-area" ref={ref}>
          {items.map((_, index) => (
            // <div
            //   key={index}
            //   className="barcode-label"
            //   style={{
            //     width: "113px",    // 30mm
            //     height: "189px",   // 50mm
            //     border: "1.5px solid #000",  // ✅ clean border
            //     borderRadius: "3px",
            //     display: "flex",
            //     flexDirection: "row",  // ✅ row — barcode left, text right
            //     alignItems: "center",
            //     justifyContent: "center",
            //     marginBottom: "8px",
            //     overflow: "hidden",
            //     boxSizing: "border-box",
            //     padding: "3px",
            //     gap: "2px",
            //   }}
            // >
            //   {/* ✅ Barcode — 90 degrees */}
            //   <div
            //     style={{
            //       transform: "rotate(90deg)",
            //       transformOrigin: "center center",
            //       width: "170px",
            //       height: "85px",
            //       display: "flex",
            //       alignItems: "center",
            //       justifyContent: "center",
            //       flexShrink: 0,
            //     }}
            //   >
            //     <Barcode
            //       value={data.barcode || "N/A"}
            //       width={1.1}
            //       height={70}
            //       format="CODE128"
            //       displayValue={true}
            //       fontSize={8}
            //       margin={1}
            //     />
            //   </div>

            //   {/*  Material name — right side, 90 degrees */}
            //   <div
            //     style={{
            //       display: "flex",
            //       flexDirection: "column",
            //       alignItems: "center",
            //       justifyContent: "center",
            //       flexShrink: 0,
            //       width: "22px",
            //     }}
            //   >
            //     <span
            //       style={{
            //         transform: "rotate(90deg)",
            //         transformOrigin: "center center",
            //         whiteSpace: "nowrap",
            //         fontSize: "7px",
            //         fontWeight: "bold",
            //         display: "block",
            //         width: "170px",
            //         textAlign: "center",
            //       }}
            //     >
            //       {/* {data.materialCode} | {data.materialDescription} */}
            //       <strong>{data.materialDescription}</strong>
            //     </span>
            //   </div>
            // </div>
            <div
              key={index}
              className="barcode-label"
              style={{
                width: "113px",
                height: "189px",
                // border: "1.5px solid #000",
                borderRadius: "3px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                margin: "6px",
                marginBottom: "8px",
                overflow: "hidden", //  overflow hidden to ensure content doesn't spill out
                boxSizing: "border-box",
                padding: "4px",
                gap: "2px",
                position: "relative", //  add this
              }}
            >
              {/*  Barcode wrapper — strictly contained */}
              <div
                style={{
                  width: "85px",
                  height: "160px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    transform: "rotate(90deg)",
                    transformOrigin: "center center",
                    width: "155px",
                    height: "80px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Barcode
                    value={data.barcode || "N/A"}
                    width={1.0}
                    height={58}
                    format="CODE128"
                    displayValue={true}
                    fontSize={15}
                    fontWeight={30}
                    margin={1}
                  />
                </div>
              </div>

              {/*  Material name — right side */}
              <div
                style={{
                  width: "20px",
                  height: "160px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  flexShrink: 0,
                }}
              >
                <span
                  style={{
                    transform: "rotate(90deg)",
                    transformOrigin: "center center",
                    whiteSpace: "nowrap",
                    fontSize: "6px",
                    fontWeight: "bold",
                    width: "155px",
                    textAlign: "center",
                    display: "block",
                  }}
                >
                  {/* {data.materialCode} | {data.materialDescription} */}
                </span>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  });
  const openPrintModal = (row, type) => {
    setPrintRowData(row);
    setPrintType(type); // 'BARCODE' or 'QR'
    setPrintQuantity(1); // Reset to 1 every time
    setShowPrintModal(true);
  };

  // // React-to-print hooks
  // const handlePrintBarcode = useReactToPrint({
  //   contentRef: barcodeRef,
  //   documentTitle: "Barcode_Print",
  //   onAfterPrint: () => setShowPrintModal(false), // Print ayyaka modal close
  // });
  //   const handlePrintBarcode = useReactToPrint({
  //   contentRef: barcodeRef,
  //   documentTitle: "Barcode_Print",
  //   pageStyle: `@page { size: 30mm 50mm; margin: 0mm; }`,  // ✅ ADD THIS LINE
  //   onAfterPrint: () => setShowPrintModal(false),
  // });

  const handlePrintBarcode = useReactToPrint({
    contentRef: barcodeRef,
    documentTitle: "Barcode_Print",
    pageStyle: `@page { size: 30mm 50mm; margin: 0mm; }`, // portrait label
    onAfterPrint: () => setShowPrintModal(false),
  });

  const handlePrintQr = useReactToPrint({
    contentRef: qrCodeRef,
    documentTitle: "QR_Print",
    onAfterPrint: () => setShowPrintModal(false),
  });

  const handleFinalPrint = () => {
    if (printType === "BARCODE") {
      handlePrintBarcode();
    } else if (printType === "QR") {
      handlePrintQr();
    }
  };

  // const [selectedRowForPrint, setSelectedRowForPrint] = useState(null);

  // const handlePrintBarcode = useReactToPrint({
  //   contentRef: barcodeRef,
  //   documentTitle: "Barcode_Print",
  // });

  // const handlePrintQr = useReactToPrint({
  //   contentRef: qrCodeRef,
  //   documentTitle: "QR_Print",
  // });

  const isRentGodown = materialData?.some((row) => row.godown === "Rent");

  const rentOnlyColumns = [
    {
      name: "Created On",
      selector: (row) => row.createdOn || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-success">
          {formatDate(row.createdOn)}
        </p>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "ROI (Months)",
      selector: (row) => row.roiCodeMonths || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">{row.roiCodeMonths}</p>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "ROI Expiry Date",
      selector: (row) =>
        getRoiExpiryDate(row.createdOn)
          ? formatDate(getRoiExpiryDate(row.createdOn))
          : "--",
      cell: (row) => {
        const expiryDate = getRoiExpiryDate(row.createdOn);
        return (
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {expiryDate ? formatDate(expiryDate) : "--"}
          </p>
        );
      },
      sortable: true,
      width: "160px",
    },
    {
      name: "ROI Age",
      selector: (row) => getRoiAgeMonthsDays(row.createdOn || row.createdDate),
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">
          {getRoiAgeMonthsDays(row.createdOn || row.createdDate)}
        </p>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Monthly ROI Amt",
      selector: (row) => row.monthlyRoiAmount || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">
          {row.monthlyRoiAmount} INR
        </p>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "AC Asset Type",
      selector: (row) => row.acAssetType || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">{row.acAssetType}</p>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Asset Status",
      cell: (row) => (
        <TableStatusField
          status={row.assetActiveInactive ? "Active" : "Inactive"}
        />
      ),
      width: "130px",
    },
  ];
  const getAgeingBucket = (row) => {
    const days = row.ageingDays;

    if (days >= 0 && days <= 30) return "0-30";
    if (days >= 31 && days <= 60) return "31-60";
    if (days >= 61 && days <= 90) return "61-90";
    if (days >= 91 && days <= 180) return "91-180";
    if (days >= 181 && days <= 365) return "181-365";
    if (days > 365) return "Over 365";

    return "--";
  };
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const [showBarcodeHistoryModal, setShowBarcodeHistoryModal] = useState(false);
  const [selectedBarcodeHistory, setSelectedBarcodeHistory] = useState([]);

  const [showBarcodeExtendModal, setShowBarcodeExtendModal] = useState(false);
  const [selectedBarcodeExtendRow, setSelectedBarcodeExtendRow] =
    useState(null);
  //  const [showBarcodeExtendModal, setShowBarcodeExtendModal] = useState(false);

  const handleViewBarcodeExtendHistory = (row) => {
    if (!row?.barcodeExtendHistory?.length) {
      toast.warning("No Barcode Extend history found");
      return;
    }
    // eslint-disable-next-line
    const handleBarcodeExtend = () => {
      setShowBarcodeExtendModal(false);
      setSelectedBarcodeExtendRow(null);
    };

    setSelectedBarcodeExtendRow(row);
    setShowBarcodeExtendModal(true);
  };

  const handleViewConversionHistory = (row) => {
    setSelectedRowData(row);
    setShowHistoryModal(true);
  };
  const handleViewBarcodeERFHistory = (row) => {
    setSelectedBarcodeHistory(row.barcodeERFHistory);
    setShowBarcodeHistoryModal(true);
  };
  const getLatestBarcodeHistory = (row) => {
    if (!row?.barcodeERFHistory?.length) return null;
    return row.barcodeERFHistory[row.barcodeERFHistory.length - 1];
  };

  const columns = [
    {
      name: "Edit Barcode",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            className="btn d-flex align-items-center w-100 text-success"
            // onClick={DeleteMaterial}
            onClick={() => showAddProduct12("EDIT", row.documentNumber, row)}
          >
            <i class="bi bi-pencil-square pe-2"></i>{" "}
            {/* <sapn className="m-0 p-0 pt-1">Edit </sapn> */}
          </button>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Edit ROI",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            className="btn d-flex align-items-center w-100"
            // onClick={DeleteMaterial}
            onClick={() => showAddProduct("EDIT", row.documentNumber, row)}
          >
            <i class="bi bi-pencil-square pe-2"></i>{" "}
            {/* <sapn className="m-0 p-0 pt-1">Edit </sapn> */}
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },

    {
      name: "Barcode Code",
      id: "barcode",
      // id1:"materialDescription",
      // dropDown: true,
      selector: (row) => row.barcode || "--",
      cell: (row) => (
        <div className="ms-2">
          <p className="m-0 p-0 pt-1 fw-medium">{row?.barcode} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    // Inside your columns array:

    {
      name: "Barcode",
      cell: (row) => (
        <button
          className="btn btn-sm d-flex align-items-center gap-1"
          style={{ backgroundColor: "#98d8d8", fontWeight: "bold" }}
          // OLD: onClick={() => triggerPrint(row)}
          // NEW:
          onClick={() => openPrintModal(row, "BARCODE")}
          title="Print Barcode"
        >
          <i className="bi bi-upc-scan"></i>
          Print
        </button>
      ),
      width: "120px",
    },
    {
      name: "QR Code",
      cell: (row) => (
        <button
          className="btn btn-sm d-flex align-items-center gap-1"
          style={{ backgroundColor: "#98d8d8", fontWeight: "bold" }}
          // OLD: onClick={() => triggerPrintQrCode(row)}
          // NEW:
          onClick={() => openPrintModal(row, "QR")}
          title="Print QR Code"
        >
          <i className="bi bi-qr-code-scan"></i>
          Print QR
        </button>
      ),
      width: "130px",
    },

    {
      name: "Code",
      id: "materialCode",
      // id1:"materialDescription",
      // dropDown: true,
      selector: (row) => row.productName || "--",
      cell: (row) => (
        // <div className="d-flex justify-content-center w-50 align-items-center cursor-pointer">

        <div className="flex justify-center items-center">
          <div className="ms-2">
            <p className="m-0 p-0 pt-1 fw-bold">{row?.materialCode} </p>

            <p className="m-0 p-0 pt-1 fw-bold text-success">
              {row.materialDescription}{" "}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      width: "300px",
    },

    {
      name: "Qty",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{"1"} </p>
        </div>
      ),
      sortable: true,
      width: "80px",
    },

    {
      name: "Vendor Rate",
      selector: (row) => row.unitPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {row.orderPriceUnit ?? row.unitPrice}{" "}
          </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "M R P",
      selector: (row) => row.mrPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.mrPrice} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Quality Check",
      width: "260px",
      cell: (row) => (
        <div className="d-flex gap-4 ms-1 align-items-center">
          {/*  PHYSICAL QC */}
          <div
            className="d-flex align-items-center gap-1 cursor-pointer"
            onClick={() => {
              if (row.hasPhysicalQC) {
                handleViewQC("PHYSICAL", row);
              } else {
                handleQCCheck("PHYSICAL", row);
              }
            }}
            title={row.hasPhysicalQC ? "View Physical QC" : "Add Physical QC"}
          >
            <i
              className={`bi ${
                row.hasPhysicalQC
                  ? "bi-check-circle-fill text-success"
                  : "bi-clipboard-plus text-primary"
              } fs-5`}
            />
            <span className="fw-bold">Physical</span>
          </div>

          {/* 🔹 SPECIFICATION QC */}
          <div
            className="d-flex align-items-center gap-1 cursor-pointer"
            onClick={() => {
              if (row.hasSpecificationQC) {
                handleViewQC("SPECIFICATION", row);
              } else {
                handleQCCheck("SPECIFICATION", row);
              }
            }}
            title={
              row.hasSpecificationQC
                ? "View Specification QC"
                : "Add Specification QC"
            }
          >
            <i
              className={`bi ${
                row.hasSpecificationQC
                  ? "bi-check-circle-fill text-success"
                  : "bi-clipboard-plus text-primary"
              } fs-5`}
            />
            <span className="fw-bold">Specification</span>
          </div>
        </div>
      ),
    },
    {
      name: "History",
      cell: (row) => (
        <div className="flex items-center justify-center">
          {row.conversionHistory && row.conversionHistory.length > 0 ? (
            <div
              title="View Conversion History"
              onClick={() => handleViewConversionHistory(row)}
              className="relative cursor-pointer group"
            >
              {/* Icon */}
              <i className="bi bi-clock-history text-sky-500 text-2xl group-hover:scale-110 transition-transform duration-200"></i>

              {/* Badge */}
              <span className="absolute -top-1 -right-3 bg-sky-500 text-[10px] px-1.5 py-[1px] rounded-full text-white font-medium">
                {row.conversionHistory.length}
              </span>
            </div>
          ) : (
            <span className="text-gray-400 text-xs">--</span>
          )}
        </div>
      ),
      width: "90px",
    },

    ...(isRentGodown ? rentOnlyColumns : []),

    {
      name: "Godown",
      selector: (row) => row.godown,
      sortable: true,
      width: "130px",
      cell: (row) => {
        const value = row.godown;

        const color =
          value === "Rent" ? "red" : value === "Sale" ? "green" : "inherit";

        return <span style={{ color, fontWeight: 600 }}>{value}</span>;
      },
    },
    {
      name: "Ageing Days",
      selector: (row) => row.ageingDays ?? "--",
      cell: (row) => (
        <p className="m-0 p-0 fw-bold">{row.ageingDays ?? "--"}</p>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "Ageing Bucket",
      selector: (row) => getAgeingBucket(row),
      cell: (row) => {
        const bucket = getAgeingBucket(row);

        const color =
          bucket === "0-30"
            ? "green"
            : bucket === "31-60"
              ? "orange"
              : bucket === "61-90"
                ? "darkorange"
                : bucket === "91-180"
                  ? "red"
                  : bucket === "181-365"
                    ? "maroon"
                    : bucket === "Over 365"
                      ? "black"
                      : "inherit";

        return <span style={{ color, fontWeight: 600 }}>{bucket}</span>;
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "Assiging Barcode",
      selector: (row) => row.assignBarcode || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {row.assignBarcode ? "true" : "--"}{" "}
          </p>
        </div>
      ),
      sortable: true,
      width: "165px",
    },

    {
      name: "ERF Item Nr",
      selector: (row) => getLatestBarcodeHistory(row)?.equipmentItemNr ?? "--",
      cell: (row) => {
        const latest = getLatestBarcodeHistory(row);

        return (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">
              {latest?.equipmentItemNr ?? "--"}
            </p>
          </div>
        );
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "ERF Nr",
      selector: (row) => getLatestBarcodeHistory(row)?.equipmentRentNr ?? "--",
      cell: (row) => {
        const latest = getLatestBarcodeHistory(row);

        return (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">
              {latest?.equipmentRentNr ?? "--"}
            </p>
          </div>
        );
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "Material Status",

      selector: (row) => row.materialStatus || "--",

      cell: (row) => {
        const status = row.materialStatus;

        const statusColor =
          status === "StockIn"
            ? "text-success"
            : status === "StockOut"
              ? "text-danger"
              : "text-muted";

        return (
          <div>
            <p className={`m-0 p-0 pt-1 fw-bold ${statusColor}`}>
              {status ?? "--"}
            </p>
          </div>
        );
      },

      sortable: true,

      width: "165px",
    },

    {
      name: "Barcode ERF",
      width: "120px",
      cell: (row) => (
        <div className="flex items-center justify-center">
          {row.barcodeERFHistory && row.barcodeERFHistory.length > 0 ? (
            <div
              title="View Barcode ERF History"
              onClick={() => handleViewBarcodeERFHistory(row)}
              className="relative cursor-pointer group"
            >
              {/* Icon */}
              <i className="bi bi-upc-scan text-green-600 text-2xl group-hover:scale-110 transition-transform duration-200"></i>

              {/* Count badge */}
              <span className="absolute -top-1 -right-3 bg-green-600 text-[10px] px-1.5 py-[1px] rounded-full text-white font-medium">
                {row.barcodeERFHistory.length}
              </span>
            </div>
          ) : (
            <span className="text-gray-400 text-xs">--</span>
          )}
        </div>
      ),
    },

    {
      name: "Barcode Extend",
      width: "130px",
      cell: (row) => (
        <div className="flex items-center justify-center">
          {row.barcodeExtendHistory && row.barcodeExtendHistory.length > 0 ? (
            <div
              title="View Barcode Extend History"
              onClick={() => handleViewBarcodeExtendHistory(row)}
              className="relative cursor-pointer group"
            >
              {/* Icon */}
              <i className="bi bi-arrow-repeat text-blue-500 text-2xl group-hover:scale-110 transition-transform duration-200"></i>

              {/* Badge */}
              <span className="absolute -top-1 -right-3 bg-blue-400 text-[10px] px-1.5 py-[1px] rounded-full text-white font-medium">
                {row.barcodeExtendHistory.length}
              </span>
            </div>
          ) : (
            <span className="text-gray-400 text-xs">--</span>
          )}
        </div>
      ),
    },

    {
      name: "Details",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 150, hide: 200 }}
            overlay={
              <Tooltip
                id={`tooltip-${row.documentNumber}`}
                className="custom-tooltip"
                target={target.current}
              >
                <div style={{ textAlign: "left" }}>
                  {/* <strong>Location:</strong> {row.location} <br /> */}

                  <strong>Remarks:</strong>
                  {row?.remarks || "--"}
                  <br />
                  <strong>Created By:</strong>
                  {row?.createdBy || "--"}
                  <br />
                  <strong>Created Date:</strong>
                  {row?.createdDate || "--"}
                  <br />
                  <strong>Updated Date:</strong>
                  {row?.updatedDate || "--"}
                  <br />
                </div>
              </Tooltip>
            }
          >
            <button
              className="btn btn-light p-1 border-0"
              title="View Details"
              // onClick={() => handleViewDetails(row)}
            >
              <i className="bi bi-eye fs-5 text-primary"></i>
            </button>
          </OverlayTrigger>
        </div>
      ),
      width: "100px",
    },

    {
      name: "Delete",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button onClick={() => deleteMaterial(row)}>
            {/* <i class="bi bi-trash3"></i> */}
            <i className="bi bi-trash text-danger fs-4" />
          </button>
        </div>
      ),
      sortable: true,
      width: "200px",
      omit: true,
    },
  ];

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  // const handleViewFile = (fileAttachmentId) => {
  //   setFileViewData(fileAttachmentId);
  //   setShowFileViewModal(true);
  // };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const deleteMaterial = (data) => {
    setModalDeleteMaterial(true);
    setData(data);
    dispatch(addMaterial(data.documentNumber));
  };
  const [getPropsData, setPropsData] = useState();
  const showAddProduct = (mode, materialnumber, data) => {
    setModalShowAddProduct(mode);
    setPropsData(data);

    if (mode === "EDIT") {
      dispatch(addMaterial(materialnumber));
    } else if (mode === "DETAILS") {
      dispatch(addMaterial(materialnumber));
    } else {
      dispatch(addMaterial(""));
    }
  };
  // const hideModal = () => {
  //   setModalDeleteMaterial(false);
  //   setModalShowAddProduct(null);
  //   setModalShowDetailProduct(false);
  // };
  const hideModal = () => {
    setModalDeleteMaterial(false);
    setModalShowAddProduct(null);
    setModalShowDetailProduct(false);
    setTimeout(() => reloadData(), 300); // ✅ modal close తర్వాత reload
  };

  const showAddProduct12 = (mode, materialnumber, data) => {
    setModalShowAddProductMaterial(mode);
    setPropsData(data);

    if (mode === "EDIT") {
      dispatch(addMaterial(materialnumber));
    } else if (mode === "DETAILS") {
      dispatch(addMaterial(materialnumber));
    } else {
      dispatch(addMaterial(""));
    }
  };

  // const hideModalMaterial = () => {
  //   setModalDeleteMaterial(false);
  //   setModalShowAddProductMaterial(null);
  //   setModalShowDetailProduct(false);
  // };
  const hideModalMaterial = () => {
    setModalDeleteMaterial(false);
    setModalShowAddProductMaterial(null);
    setModalShowDetailProduct(false);
    setTimeout(() => reloadData(), 300); // modal close reload
  };

  // useEffect(() => {
  //   let obj = {
  //     queryName: "MaterilBarcodeListRE",
  //     page: 1,
  //     per_page: 10,
  //   };
  //   dispatch(materialBarcodeList(obj));

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    reloadData(1, 100, "");
    // startPolling();
    // return () => stopPolling(); // cleanup
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //
  useEffect(() => {
    currentPageRef.current = currentPage;
  }, [currentPage]);
  useEffect(() => {
    perPageRef.current = getNewPerPage;
  }, [getNewPerPage]);
  useEffect(() => {
    searchTermRef.current = getCommonSearchTxt;
  }, [getCommonSearchTxt]);

  // const handlePageChange = (page) => {
  //   let obj = {
  //     queryName: "MaterilBarcodeListRE",
  //     page: page,
  //     per_page: getNewPerPage,
  //   };
  //   dispatch(materialBarcodeList(obj));
  // };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    currentPageRef.current = page;
    reloadData(page, perPageRef.current, searchTermRef.current);
  };
  // const handlePerRowsChange = async (newPerPage, page) => {
  //   let obj = {
  //     queryName: "MaterilBarcodeListRE",
  //     page: page,
  //     per_page: newPerPage,
  //   };
  //   setNewPerPage(newPerPage);
  //   dispatch(materialBarcodeList(obj));
  // };
  // const handlePerRowsChange = async (newPerPage, page) => {
  //   setNewPerPage(newPerPage);
  //   setCurrentPage(page);
  //   perPageRef.current = newPerPage;
  //   currentPageRef.current = page;
  //   dispatch(
  //     materialBarcodeList({
  //       queryName: "MaterilBarcodeListRE",
  //       page,
  //       per_page: newPerPage,
  //     }),
  //   );
  // };
  const handlePerRowsChange = async (newPerPage, page) => {
    setNewPerPage(newPerPage);
    setCurrentPage(page);
    perPageRef.current = newPerPage;
    currentPageRef.current = page;
    reloadData(page, newPerPage, searchTermRef.current);
  };
  useEffect(() => {
    reloadData(1, 100, "");
    // startPolling();
    // return () => stopPolling();
    // eslint-disable-next-line
  }, []);

  // Common Search Function on button
  // const handleSearchFuncApi = async () => {
  //   let obj = {
  //     queryName: "MaterilBarcodeListRE",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: getCommonSearchTxt,
  //   };
  //   dispatch(materialBarcodeList(obj));
  // };
  const handleSearchFuncApi = async () => {
    dispatch(
      materialBarcodeList({
        queryName: "MaterilBarcodeListRE",
        page: 1,
        per_page: 100,
        searchTerm: getCommonSearchTxt,
      }),
    );
  };
  // const [data, setDataFilter] = useState();
  const [filterShow, setFilterShow] = useState(false);

  // const handleFilterData = async (filters) => {
  //   const obj = {
  //     queryName: "MaterilBarcodeListRE",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: "",
  //     rowFilter: filters.length > 0 ? { $and: filters } : {},
  //   };

  //   dispatch(materialBarcodeList(obj));

  // };
  const handleFilterData = async (filters) => {
    setActiveFilters(filters);
    activeFiltersRef.current = filters;
    reloadData(1, perPageRef.current, "", filters);
  };

  // const columnsForFilter = columns
  //   .filter((col) => col.id || col.selectorKey)
  //   .map((col) => ({
  //     name: col.name,
  //     selectorKey: col.id || col.selectorKey,
  //     dropDown: col.dropDown || false,
  //     range: col.range || false,
  //     month: col.month || false,
  //   }));

  const filterColumns = [
    {
      id: "barcode",
      name: "Barcode Value",
      selectorKey: "barcode",
    },
    {
      id: "materialCode",
      name: "Material Code",
      selectorKey: "materialCode",
    },
    {
      id: "mrPrice",
      name: "MRP",
      selectorKey: "mrPrice",
      numberRange: true,
    },
    {
      id: "materialStatus",
      name: "Material Status",
      selectorKey: "materialStatus",
      dropDown:true,
      staticOptions:["StockIn", "StockOut"]
    },
    {
      id: "materialDescription",
      name: "Material Name",
      selectorKey: "materialDescription",
    },
    {
      id: "createdOn",
      name: "Date",
      selectorKey: "createdOn",
      month: true,
    },
  ];
  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Rent Material Barcode List</h2>
                <p className="subText">Rent Material Barcode List</p>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            {filterShow && (
              <MultiColumnFilter
                columns={filterColumns}
                data={getData}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            {/* material */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MD</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">
                        Rent Material Barcode Details
                      </span>
                      <span className="subHeaderTitle">
                        Rent Material Barcode and ROI{" "}
                      </span>
                    </Col>
                    <Col
                      xs={12}
                      md={8}
                      lg={8}
                      className="headerButtonAlign"
                    ></Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          // columns={columns}
                          // data={materialData}
                          key={`table-${materialData?.length ?? 0}`}
                          title=""
                          columns={columns}
                          data={materialData ?? []}
                          // progressPending={purchaseOrderData?.status}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_REPORT_PER_PAGE
                          }
                          pagination
                          paginationServer
                          paginationPerPage={getNewPerPage}
                          paginationTotalRows={materialTable?.total || ""}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                    <Modal
                      show={showPrintModal}
                      onHide={() => setShowPrintModal(false)}
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          Print {printType === "QR" ? "QR Code" : "Barcode"}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group>
                          <Form.Label>Enter Quantity (Copies)</Form.Label>
                          <Form.Control
                            type="number"
                            min="1"
                            value={printQuantity}
                            onChange={(e) =>
                              setPrintQuantity(parseInt(e.target.value) || 1)
                            }
                            disabled={TruckElectric}
                            autoFocus
                          />
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={() => setShowPrintModal(false)}
                        >
                          Close
                        </Button>
                        <Button variant="primary" onClick={handleFinalPrint}>
                          Print Copies
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    <Modal
                      show={showBarcodeHistoryModal}
                      onHide={() => setShowBarcodeHistoryModal(false)}
                      size="lg"
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Barcode ERF History</Modal.Title>
                      </Modal.Header>

                      <Modal.Body>
                        {selectedBarcodeHistory?.length > 0 ? (
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Status</th>
                                <th>ERF Nr</th>
                                <th>Item Nr</th>
                                <th>Type</th>
                                <th>Updated By</th>
                                <th>Date</th>
                                <th>ERF Status</th>
                              </tr>
                            </thead>

                            <tbody>
                              {selectedBarcodeHistory.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.status}</td>
                                  <td>{item.equipmentRentNr}</td>
                                  <td>{item.equipmentItemNr}</td>
                                  <td>{item.erfTypeCode}</td>
                                  <td>{item.updatedByName}</td>
                                  <td>
                                    {item.updatedAt
                                      ? new Date(
                                          item.updatedAt,
                                        ).toLocaleString()
                                      : "--"}
                                  </td>
                                  <td>{item.erfStatus}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <p className="text-center">No history found</p>
                        )}
                      </Modal.Body>
                    </Modal>
                    <Modal
                      show={showBarcodeExtendModal}
                      // onHide={handleBarcodeExtend}setShowBarcodeExtendModal
                      onHide={() => setShowBarcodeExtendModal(false)}
                      size="lg"
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Barcode Extend History</Modal.Title>
                      </Modal.Header>

                      <Modal.Body>
                        {selectedBarcodeExtendRow?.barcodeExtendHistory
                          ?.length > 0 ? (
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <thead className="table-light">
                                <tr>
                                  <th>Status</th>
                                  <th>ERF Nr</th>
                                  <th>Item Nr</th>
                                  <th>Extended By</th>
                                  <th>Date</th>
                                  <th>ERF Status</th>
                                </tr>
                              </thead>

                              <tbody>
                                {selectedBarcodeExtendRow.barcodeExtendHistory.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item.status || "--"}</td>
                                      {/* <td>{item.equipmentRentNr || "--"}</td> */}
                                      <td>
                                        {selectedBarcodeExtendRow
                                          ?.barcodeERFHistory?.[0]
                                          ?.equipmentRentNr &&
                                        item.equipmentExtNr
                                          ? `${selectedBarcodeExtendRow.barcodeERFHistory[0].equipmentRentNr} / ${item.equipmentExtNr}`
                                          : "--"}
                                      </td>
                                      <td>{item.equipmentItemNr || "--"}</td>
                                      <td>{item.createdByName || "--"}</td>
                                      <td>
                                        {item.createdAt
                                          ? new Date(
                                              item.createdAt,
                                            ).toLocaleString()
                                          : "--"}
                                      </td>
                                      <td>{item.erfStatus || "--"}</td>
                                    </tr>
                                  ),
                                )}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <p className="text-center text-muted">
                            No extend history available
                          </p>
                        )}
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <DeleteMaterialV5
        show={modalDeleteMaterial}
        onHide={() => hideModal()}
        data={getData}
        // dropdownData={getAccountGroup}
      />
      <MaterialBarCodeModal
        show={modalShowAddProduct}
        onHide={() => {
          setModalShowAddProduct(null);
          setModalShowDetailProduct(false);
        }}
        data={getPropsData}
        perPage={getNewPerPage}
        queryName="MaterilBarcodeListRE"
      />
      {/* <MaterialHBModalV5
        show={modalShowAddProductMaterial}
        // show={true}
        onHide={() => hideModalMaterial()}
        data={getPropsData}
      /> */}

      <MaterialHBModalV5Barcode
        show={modalShowAddProductMaterial}
        // show={true}
        onHide={() => hideModalMaterial()}
        data={getPropsData}
        type={"RE"}
      />

      <CatalogProductDetailModalV5
        show={modalShowDetailProduct}
        onHide={() => hideModal()}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <MaterialListQualityCheckModal
        show={showQCModal}
        onHide={() => setShowQCModal(false)}
        qcType={qcType}
        rowData={selectedRow}
        // editMode={editMode}
        onSaveQualityCheck={handleSaveQualityCheck}
      />
      <ConversionHistoryModal
        show={showHistoryModal}
        onHide={() => setShowHistoryModal(false)}
        data={selectedRowData}
      />
      {/* <div style={{ display: "none" }}>
      <BarcodePrintComponent ref={componentRef} data={printData} />
    </div> */}
      <div style={{ display: "none" }}>
        <PrintableBarcode
          ref={barcodeRef}
          data={printRowData}
          quantity={printQuantity}
        />
        <PrintableQrcode
          ref={qrCodeRef}
          data={printRowData}
          quantity={printQuantity}
        />
      </div>
    </main>
  );
};

export default MaterialBarcodeList;
